import { videoFormToQuery as formToQuery } from "./videoFormToQuery";
import { videoQueryToForm as queryToForm } from "./videoQueryToForm";

export default { queryToForm, formToQuery };
